export const PROJECTFIX = "Self";
export const PROJECTEND = "care";
export const PROJECT = `${PROJECTFIX}${PROJECTEND}`; // 项目的key

/* Project */
export const APICATEGORY = {
    ADD: "ADD",
    REMOVE: "REMOVE",
    CHANGE: "CHANGE",
    QUERY: "QUERY"
};

/* user profile */
export const SETTING = "SETTING";
export const LOGINOUT = "LOGINOUT";
export const USERINFO = "USERINFO";
export const USER_SCHEMAS = "user_schemas";
export const USER_STEP = "user_step";

/* Header菜单 */
export const MENU = "MENU";

/* 工具栏 */
export const DRAWER = {
    OPEN: "OPEN",
    ANCHOR: "ANCHOR",
    WIDTH: "WIDTH"
};

/* 工具栏 - 设置的模块内容 */
export const TOOLBAR = {
    MODULES: {
        TEMPLATE: "TEMPLATE",
        COLOR: "COLOR",
        CONTROL: "CONTROL",
        TOOLS: "TOOLS"
    },
    CONFIG: "CONFIG",
    COLOR: "COLOR"
};

/* ESSO */
export const ESSO = {
    ESSOOPEN: "ESSOOPEN", // 是否开启
    ESSOSYSTEMSUPPORT: "ESSOSYSTEMSUPPORT", // 系统是否支持
    ESSOLOCAL: "ESSOLOCAL", // 是否开启本地
    ESSOCROSSBROWSER: "ESSOCROSSBROWSER", // 是否支持跨浏览器
    TOKEN: "TOKEN", // token
    TEMPISNOTTAKERUNINTERFACE: "tempIsNotTakeRunInterface" // token
};

/* 应用 */
export const APP = {
    LIST: "LIST", // 应用列表
    SOURCEDATA: "SOURCEDATA", // 应用帐号数据
    DEFAULTACCOUNTKEY: "DEFAULTACCOUNTKEY", // 默认应用帐号key
    ISSHOWFORM: "ISSHOWFORM", // 是否显示表单
};

/* token */
export const TOKEN = "TOKEN";

// 权限
export const BUTTONAUTH = "BUTTONAUTH"; // 按钮的权限
export const MENULIST = "MENULIST"; // 菜单列表
export const HASHMENUMAPPING = "HASHMENUMAPPING"; // 菜单列表
export const CURRENT_MENU = "CURRENT_MENU"; // 菜单列表